
import {
  schema, normalize
} from 'normalizr';

// Define categories schema
const categorySchema = new schema.Entity('categories')
const categoryListSchema = [categorySchema]

export function adaptCategoriesToStore({ data }) {
  const entries = normalize(data.results, categoryListSchema)

  return {
    entries: entries.entities.categories,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}